import { gql } from "@apollo/client"
export const GET_COMPANY = gql`
query GetCompany($id:UUID!){
  company(id: $id){
    id
    name
    abbreviation
    type
    paidUsers
    activeUsers
    persons{
      id
      firstName
      lastName
      status
      sessions{
        id
      }
      role {
        id
        name
      }
    }
    locations{
      id
          name
          streetLineOne
          streetLineTwo
          city
          country
          state
          postalCode
          customFields
          {
            id
            name
            type
            required
            description
          }
          totalStudents
          totalStaff
    }
    companySubscriptions{
      id
      startDate
      endDate
      status
      subscription {
        name
        id
      }
    }
    companyConsentPolicy{
        needParentalConsent
        autoParentalConsent
        timeoutWindow
      }
    companyInterventionPolicy{
        abuseAtHome
        safeAtHome
        suicide
      }
    }
}
`